import { Navigator } from '@shared/util/navigation';

export async function showRateAppPopupSeries(_recentMessageCount: number, _navigator?: Navigator) {
  // do nothing
}
